import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  openRemoveTemplateModal = () => {
    const {
      openRemoveTemplateModal
    } = this.props.metadata.customComponentMetadata;
    const uid = this.props.rowData.uid;
    openRemoveTemplateModal(uid);
  };

  openEditTemplateModal = () => {
    const {
      openEditTemplateModal
    } = this.props.metadata.customComponentMetadata;
    const uid = this.props.rowData.uid;
    openEditTemplateModal(uid);
  };

  render() {
    const {
      onDeletePageList,
      onEditPageList
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openRemoveTemplateModal}>usuń</a>
              <br />
              <a onTouchTap={this.openEditTemplateModal}>edytuj</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    if (e.target.className !== "icon-table link") {
      const { history } = this.props;
      history.pushState(
        "/templates/:uid",
        `/templates/${row.props.data.uid}`,
        {}
      );
    }
  };

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        templates: {
          templates: {
            search: templatesSearch,
            meta: templatesMeta,
            sort: templatesSort
          }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setTemplatesPaginationPage(0);
      let isDirectionAscending = templatesSort.isDirectionAscending;
      if (field === templatesSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortTemplates(field, isDirectionAscending);
      this.getTemplates();
    }
  };

  getTemplates = () => {
    const {
      actions,
      notificationSystem,
      templates: { templates: { meta: templatesMeta, sort: templatesSort } }
    } = this.props;
    actions.clearForm("templates", "createTemplate");
    actions
      .getTemplates(templatesMeta, templatesSort)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  openRemoveTemplateModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveTemplateModalVisible(uid);
  };

  closeRemoveTemplateModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveTemplateModalVisible(false);
  };

  removeTemplate = () => {
    const {
      actions,
      templates: { templates: { isRemoveModalVisible, entities: templates } },
      notificationSystem
    } = this.props;
    actions.removeTemplate(isRemoveModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        this.getTemplates();
      }
    });
    actions.setIsRemoveTemplateModalVisible(false);
  };

  openEditTemplateModal = uid => {
    const { actions } = this.props;
    actions.setIsEditTemplateModalVisible(uid);
  };

  closeEditTemplateModal = () => {
    const { actions } = this.props;
    actions.setIsEditTemplateModalVisible(false);
  };

  updateTemplate = () => {
    const {
      actions,
      templates: { templates: { isEditModalVisible, entities: templates } },
      notificationSystem
    } = this.props;
    let data = {
      name: templates.getIn([isEditModalVisible, "name"])
    };
    if (templates.getIn([isEditModalVisible, "slug"]) !== isEditModalVisible) {
      data.slug = templates.getIn([isEditModalVisible, "slug"]);
    }
    actions
      .updateTemplate(data, templates.getIn([isEditModalVisible, "uid"]))
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          this.getTemplates();
        }
      });
    actions.setIsEditTemplateModalVisible(false);
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      templates: {
        templates: {
          isRemoveModalVisible,
          isEditModalVisible,
          loading,
          entities: templates,
          meta: { currentPage, limit },
          sort
        }
      },
      locales: { locales: { defaultLocale } }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveTemplateModal: this.openRemoveTemplateModal,
          openEditTemplateModal: this.openEditTemplateModal
        }
      }
    ];

    let data = [];
    let index = 0;

    if (templates) {
      templates.forEach(function(template) {
        template = template.toJS();
        index++;
        template.index = index + currentPage * limit;
        data = data.concat(template);
      });
    }

    const inputCustomProps = {
      feature: "templates",
      actions: actions,
      entity: templates.get(isEditModalVisible),
      uid: isEditModalVisible
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={sort.field}
          externalSortAscending={sort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveTemplateModal}
            enterAction={this.removeTemplate}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.removeTemplate}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeRemoveTemplateModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditTemplateModal}
            enterAction={this.updateTemplate}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Edytuj tytuł wpisu</h3>
              <InputCustom field={["name"]} {...inputCustomProps} />
              <InputCustom field={["slug"]} {...inputCustomProps} />
              <button className="error" onTouchTap={this.updateTemplate}>
                Tak
              </button>
              <button className="info" onTouchTap={this.closeEditTemplateModal}>
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/templates/table.react.js